<template>
  <div id="room">
    <img :src="roomData[currentRoomNumber].roomimage" class="roomBackground"/>
    <GameView :currentRoomData="[{room:roomData[currentRoomNumber]}]"></GameView>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GameView from '@/components/GameView'
export default {
  name: 'room',
  components: {
    GameView
  },
  computed:{
    ...mapGetters({
       // map all rooms data
       roomData: 'getRoom'
    }),
  },
  watch: {
    '$route' () {
      // update room id on route change
      this.currentRoomNumber = this.$route.params.id
    }
  },
  data(){
    return{
       // set up start
       currentRoomNumber: this.$route.params.id
    }
  }
}
</script>
<style lang="scss" scoped>


</style>
